import { ContainerElement, ItemsContainer, ItemBox} from "./stats.style";

const HeadStats = ({title}) => {
  
  const [firstWord, secondWord ] = title.split(' ');

  return (
    <ContainerElement>
      <ItemsContainer>
        <ItemBox>
            <span className='price'>9.0K <br />Items</span>
        </ItemBox>
        <ItemBox>
          <span className='price'>2.2K</span>
          <span className='item-name'>Owners</span>
        </ItemBox>
        <ItemBox>
          <span className='price'>$1.02</span>
          <span className='item-name'>Floor Price</span>
        </ItemBox>
        <ItemBox>
          <span className='price'>$9.02K</span>
          <span className='item-name'>Volume Traded</span>
        </ItemBox>
        <ItemBox>
          <h3 className='alpha'>{firstWord} <br />{secondWord}</h3>
        </ItemBox>
      </ItemsContainer>
      <p className='description'>
      Mad Ⓥ-Apes is an NFT collection comprised of 9,999 mad apes! 
      These apex predators were looking for an environment free of contamination, 
      and they found the best one imaginable here in the VeChain metaverse!
      </p>
    </ContainerElement>
  )
}

export default HeadStats;